import { type ChangeEventHandler, type FC } from 'react';
import { useUnit } from 'effector-react';
import { Flex, MultiSelect, TextInput } from '@mantine/core';
import { type PayinTraderStatus, payinTraderStatuses } from '~/entities/payin';
import { useDebouncedField } from '~/shared/lib/hooks/useDebouncedField';
import { $tradersFilter, setTradersFilter } from '../model';
import { debounceTimeout } from '../constants';

export const TradersFilter: FC = () => {
    const values = useUnit($tradersFilter);

    const traderName = useDebouncedField({
        initialValue: values.traderName?.value ?? '',
        delay: debounceTimeout,
        onChange: (value: string) => setTradersFilter({ traderName: { value } }),
    });

    const handleChangeTraderName: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
        traderName.onChange(value);
    };

    return (
        <Flex
            wrap='wrap'
            gap='md'
            w='100%'
        >
            <MultiSelect
                size='xs'
                flex={1}
                miw={240}
                searchable
                label='Статусы'
                value={values.statuses}
                data={payinTraderStatuses}
                onChange={(value) => setTradersFilter({ statuses: value as PayinTraderStatus[] })}
                clearable
            />

            <TextInput
                flex={1}
                size='xs'
                miw={240}
                label='Имя трейдера'
                value={traderName.value}
                onChange={handleChangeTraderName}
            />

            {/* <MultiSelect
                flex={1}
                size='xs'
                miw={240}
                searchable
                label='Статус работы'
                value={values.workingStatuses}
                data={payinTraderWorkingStatuses}
                onChange={(value) => setTradersFilter({ workingStatuses: value as PayinTraderWorkingStatus[] })}
                clearable
            /> */}
        </Flex>
    );
};
